import React from 'react';
import { Col, Row, Card } from 'antd'; // 引入 Ant Design 的列、行和卡片组件
import { token, lang, baseURL } from '../../api/config'; // 引入配置文件中的 token、语言和 baseURL
import '../../assets/iconfont.css'; // 引入字体图标样式
import styles from './index.module.less'; // 引入局部样式

export default function ChangeLog({ changelogs = [] }) {
  return (
    <div className='singular-row'>
      <Row gutter={[20, 20]}>
        {changelogs.map((changelogObject, index) => {
          const key = Object.keys(changelogObject)[0]; // 获取对象的第一个键
          const value = changelogObject[key]; // 获取对象的第一个值

          return (
            <Col key={index} span={6}>
              <Card>
                <div className='card-content'>
                  <div className='card-content-left'>
                    <div className={styles.file_title}>
                      {`${value}_CHANGELOG`} {/* 使用值作为 changelog 名称的一部分 */}
                    </div>
                  </div>
                  <div className='download'>
                    <i
                      className='iconfont icon-download' // 使用 iconfont 中的下载图标
                      onClick={() => {
                        // 当点击下载图标时，触发 fetch 请求
                        fetch(
                          `${baseURL}/api/plm/product/series/${key}/release-notes.md?access_token=${token}&mode=inline&firmware_category=firmware&lang=${lang}`
                        )
                          .then(response => response.blob()) // 将响应转换为 Blob 对象
                          .then(blob => {
                            // 创建一个 URL 对象，并触发下载
                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = `${value}_CHANGELOG.md`; // 使用值作为下载文件名的一部分
                            document.body.appendChild(a);
                            a.click(); // 触发点击下载
                            document.body.removeChild(a); // 下载后移除链接
                          })
                          .catch(error => {
                            console.error('Error downloading file:', error); // 捕获并显示错误信息
                          });
                      }}
                    />
                  </div>
                </div>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
